module.exports = __webpack_public_path__ + "static/media/qq-qrcode-20220729.3407c263.png";